import { lazy } from "react";

export default {
  name: "About",
  path: "/about",
  component: lazy(() => import("./index"))
}